
jQuery.validator.unobtrusive.adapters.addBool("checkboxtrue");

jQuery.validator.unobtrusive.adapters.addBool("pwcheckinscription");

jQuery.validator.unobtrusive.adapters.addBool("checkpostalcodeformat");

jQuery.validator.unobtrusive.adapters.addBool("checkphoneformat");

jQuery.validator.unobtrusive.adapters.addBool("checkmobilephoneformat");

jQuery.validator.unobtrusive.adapters.addBool("checkworkphoneformat");

jQuery.validator.unobtrusive.adapters.addBool("pwcheck");

jQuery.validator.unobtrusive.adapters.addBool("checkr");

jQuery.validator.unobtrusive.adapters.addBool("donorcp");

jQuery.validator.unobtrusive.adapters.addBool("donornumber");

jQuery.validator.unobtrusive.adapters.addBool("donorbirth");

jQuery.validator.unobtrusive.adapters.addBool("datecheck");

jQuery.validator.unobtrusive.adapters.addBool("emailcheck");

jQuery.validator.unobtrusive.adapters.addBool("mdbrequired");